var map = {
	"./Avatar.vue": 7741,
	"./Body.vue": 5675,
	"./Btn.vue": 1629,
	"./Card.vue": 9457,
	"./Divider.vue": 9182,
	"./Heading.vue": 6973,
	"./Icon.vue": 5343,
	"./Img.vue": 2486,
	"./Info.vue": 4301,
	"./InfoCard.vue": 7330,
	"./NewsRecord.vue": 9593,
	"./Section.vue": 7475,
	"./SectionHeading.vue": 5138,
	"./Subheading.vue": 3343,
	"./Subtitle.vue": 5405,
	"./Title.vue": 6684
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5190;